module.exports = __webpack_public_path__ + "static/media/Astronaut.f3152ab1.glb";